import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  memberDetailActions,
  selectBillingAddressData,
} from 'features/member/reducer/memberDetailSlice';

import InformationTable from 'components/common/table/InformationTable';

import { NATIONAL_CODE } from 'constants/common/nationalCode';
import { InformationObject } from 'types/common/informationTable';

import * as S from './ConnectBillingAddress.styled';

interface Props {
  userId: string;
}

const ConnectBillingAddress = ({ userId }: Props) => {
  const dispatch = useDispatch();
  const { country, address, address2, city, state, zipCode, vatNumber } =
    useSelector(selectBillingAddressData);

  const region = NATIONAL_CODE[country];

  const billingAddressInformation: InformationObject[] = [
    { title: 'Region', render: region?.label, titleWidth: '20%' },
    { title: 'Address 1', render: address, titleWidth: '20%' },
    { title: 'Address 2', render: address2, titleWidth: '20%' },
    { title: 'City', render: city, titleWidth: '20%' },
    { title: 'State', render: state, titleWidth: '20%' },
    { title: 'Zip Code', render: zipCode, titleWidth: '20%' },
    { title: 'Vat Number', render: vatNumber, titleWidth: '20%' },
  ];

  useEffect(() => {
    dispatch(memberDetailActions.getBillingAddress({ userId }));
    return () => {
      dispatch(memberDetailActions.resetBillingAddress());
    };
  }, []);

  return (
    <S.ConnectBillingAddressWrapper>
      <InformationTable title={'[CONNECT] Billing Address'} data={billingAddressInformation} />
    </S.ConnectBillingAddressWrapper>
  );
};

export default ConnectBillingAddress;
